import { DataBox, createDataBox, createDataBoxDefault } from 'app/common/data-box-store'
import {
  GET_SCHOOL_SUBSIDY_COMPLEXES,
  convertParams as convertComplexesParams,
  convertResult as convertComplexesResult,
} from 'app/common/api/requests/reports/school_subsidy_complexes/get'
import {
  GET_SCHOOL_SUBSIDY_ORDERS_SUMS,
  convertParams as convertSumsParams,
  convertResult as convertSumsResult,
} from 'app/common/api/requests/reports/school_subsidy_orders_sums/get'
import normalizeString from 'app/common/lib/normalizeString'
import toFixedValue from 'app/common/lib/toFixedValue'
import { ItemType } from 'app/common/ui-next/plain-selector'
import { api } from 'app/api'

type SubsidiesSumsAndKits = Array<ItemType>

class SubsidiesSumsAndKitsFilterDataBox extends DataBox<SubsidiesSumsAndKits> {}

export const defaultSubsidiesSumsAndKits: SubsidiesSumsAndKits = []
export const subsidiesSumsAndKitsFilter = createDataBox(
  'subsidiesSumsAndKitsFilter',
  defaultSubsidiesSumsAndKits,
  SubsidiesSumsAndKitsFilterDataBox,
)

export const defaultSubsidiesSumsAndKitsDataReceiver = async (schoolId: string) => {
  if (!schoolId) return []

  const [sumsRes, kitsRes] = await Promise.all([
    api.request(GET_SCHOOL_SUBSIDY_ORDERS_SUMS, {
      error: 'Не удалось получить суммы справок',
      params: { schoolId },
      convertions: {
        convertParams: convertSumsParams,
        convertResult: convertSumsResult,
      },
    }),
    api.request(GET_SCHOOL_SUBSIDY_COMPLEXES, {
      error: 'Не удалось получить комплекты справок',
      params: { schoolId },
      convertions: {
        convertParams: convertComplexesParams,
        convertResult: convertComplexesResult,
      },
    }),
  ])
  const sums = (sumsRes || []).map((sum) => {
    const title = toFixedValue(sum)
    return {
      id: `sum_${title}`,
      title,
    }
  })
  const kits = (kitsRes || []).map(({ id, title }) => ({
    id: String(id),
    title: normalizeString(title),
  }))
  return [...sums, ...kits]
}

export const defaultSubsidiesSumsAndKitsSelection: Array<string> = []
export const subsidiesSumsAndKitsFilterSelection = createDataBoxDefault<Array<string>>(
  'subsidiesSumsAndKitsFilterSelection',
  defaultSubsidiesSumsAndKitsSelection,
)
